import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { SectionHeader } from '../../components/SectionHeader.js';

export const FeatureMatrix: React.FC = () => {
  const comparisonItems = [
    {
      feature: '管理者のアカウントが乗っ取られた時',
      vault: '全滅リスク（管理画面からバックアップや保持ルールを一括削除可能）',
      araya: '100% 生存（管理者であっても絶対に削除できない隔離金庫で物理保護）',
    },
    {
      feature: '「改ざんされていないこと」の客観証明',
      vault: '証明が困難（Google内部のログのみで、外部への第三者証明が難しい）',
      araya: '完全に証明可能（改ざんを100%検知する電子証明台帳を発行）',
    },
    {
      feature: '退職者アカウントの月額料金削減',
      vault: '削減不可（過去データを見るために毎月ライセンス料金を払い続ける必要がある）',
      araya: '大幅削減（データを金庫に保管したあと、アカウントを即座に解約可能）',
    },
    {
      feature: 'セキュリティ・認証の安全性',
      vault: '一般的なパスワードや二段階認証のみ',
      araya: '漏洩リスクのある秘密鍵ファイルを持たない、最新の安全連携方式',
    },
    {
      feature: 'Googleの大規模障害への備え',
      vault: 'Google Workspaceと運命を共にする（同じ環境内にあるため同時被災）',
      araya: '独立した別クラウド領域に保管するため、万が一のGoogle全面障害時も安心',
    },
    {
      feature: 'Google独自ファイル（スプレッドシート等）の閲覧',
      vault: 'Google独自形式のまま（Google解約後は開けない）',
      araya: 'PDFやExcel形式へ自動変換して保存（Google解約後でも永久に閲覧可能）',
    },
    {
      feature: 'データの復元・探しやすさ',
      vault: '全体の一括出力のみ（抽出完了まで数日かかる場合がある）',
      araya: '特定の社員・特定の日時のファイルを検索して即座にダウンロード可能',
    },
    {
      feature: '自社専用の安心感',
      vault: '一般的な共有クラウドサービス',
      araya: '御社専用の独立した環境に構築するため、他社からの影響ゼロ',
    },
  ];

  return (
    <section id="matrix" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          tag="徹底比較"
          tagVariant="emerald"
          title="Google Vault と ARAYA の決定的な違い"
          description="Google Vaultは日々のメール検索には便利ですが、ランサムウェアや管理者乗っ取りからデータを守る「隔離バックアップ」ではありません。その違いをわかりやすく比較しました。"
        />

        <div className="max-w-5xl mx-auto overflow-x-auto bg-white rounded-3xl border border-slate-200/90 shadow-sm">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="py-5 px-6 text-sm font-bold text-slate-800 w-1/3 bg-slate-50/70">比較項目・要件</th>
                <th className="py-5 px-6 text-sm font-semibold text-slate-500 w-1/3 bg-slate-50/40">
                  Google Vault (標準)
                </th>
                <th className="py-5 px-6 text-sm font-bold text-emerald-800 w-1/3 bg-emerald-50/70 border-l border-r border-emerald-200">
                  <div className="flex items-center gap-2">
                    <ShieldCheck className="w-5 h-5 text-emerald-600" />
                    <span>ARAYA (阿頼耶) Vault</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="text-xs divide-y divide-slate-100">
              {comparisonItems.map((item, index) => (
                <tr key={index} className="hover:bg-slate-50/70 transition-colors">
                  <td className="py-4 px-6 font-semibold text-slate-800 bg-slate-50/30">{item.feature}</td>
                  <td className="py-4 px-6 text-slate-600 leading-relaxed">
                    {item.vault}
                  </td>
                  <td className="py-4 px-6 text-emerald-950 font-semibold bg-emerald-50/30 border-l border-r border-emerald-200 leading-relaxed">
                    <div className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />
                      <span>{item.araya}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
